import {useRouteMatch, useHistory} from "react-router-dom";
import {Container, Row, Col} from "react-bootstrap";
import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {LazyLoadImage} from "react-lazy-load-image-component";
import {Swiper, SwiperSlide} from 'swiper/react';
import {
    BASE_URL, FOOD_PACKAGE_POST, PUBLIC_URL_SERVER, IMG_SLIDER_FOOD_PACKAGE_URL_SERVER
} from "../../../../apis";
import useWindowDimensions from "../../../../styles/lib/getWindowSize";
import _ from "lodash";
import axios from "axios";
import qs from "querystring";
import {actionGetFoodPackageDetails, actionChangeNumOfCheckedProducts, actionChangeFirstNumOfCheckedProducts} from "../../../../redux/actions/pages/foodPackage";
import CardProduct from "../../partials/card/CardProduct";
import {actionAddItemInSHoppingCard, actionRemoveItemInBasketCart} from "../../../../redux/actions/modals/modalShoppingCard";
import {toast} from "react-toastify";
import swal from 'sweetalert';

import Fab from '@mui/material/Fab';

const FoodPackage = () => {
    const match = useRouteMatch();
    const dispatch = useDispatch();
    const {token} = useSelector(state => state.user);
    const {carts} = useSelector(state => state.shoppingCart);
    const history = useHistory();


    const {
        images: banners, 
        title, 
        calory, 
        count, 
        duration, 
        description, 
        basic_products, 
        other_products, 
        ingredients_list, 
        instructions, 
        num_of_checked_products, 
        first_num_of_checked_products} = useSelector(state => state.foodPackage);

    
    const {width} = useWindowDimensions();


    useEffect(() => {
        apiGetFoodPackageDetails();
        // eslint-disable-next-line
    }, FoodPackage);


    const apiGetFoodPackageDetails = () => {
        dispatch(actionChangeNumOfCheckedProducts(0));
        axios({
            method: 'post',
            url: BASE_URL + FOOD_PACKAGE_POST,
            data: qs.stringify({
                food_package : match.params.id,
            }),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': token
            },
        }).then((response) => {
            if(response.data.status === "ok") {
                let total_checked = 0;
                response.data.package.basic_products.map(function(product){
                    if (carts.length > 0) {
                        const find_card = carts.find(cart => {
                            return cart.grades[0].gradeId === product.id ? cart : null;
                        });

                        if (find_card) {
                            product.selectedAmount = find_card.w_numbers;
                            product.is_check = true;

                            total_checked++;
                        }
                    } 
                });
                response.data.package.other_products.map(function(product){
                    if (carts.length > 0) {
                        const find_card = carts.find(cart => {
                            return cart.grades[0].gradeId === product.id ? cart : null;
                        });

                        if (find_card) {
                            product.selectedAmount = find_card.w_numbers;
                            product.is_check = true;

                            total_checked++;
                        }
                    } 
                });

                dispatch(actionGetFoodPackageDetails(response.data.package));
                dispatch(actionChangeNumOfCheckedProducts(total_checked)); // vaghti page baz mishe , age mahsoolat too sabade kharid boode bashan check mark mishan va be tedade mahsoolate entekhabi ezafe mishe, hamchenin age dasti yek mahsool check ya uncheck bheshe in method seda zade mishe
                dispatch(actionChangeFirstNumOfCheckedProducts(total_checked)); // faghat vaghti page baz mishe in seda zade mishe, tedade mahsoolati ke dar sabade kharid boodan az ghabl
            }
        });
    };

    const handelAddToShoppingCard = () => {
        let totalProductSelect = 0;
        basic_products.forEach(productItem => {
            if (productItem.is_check) {
                totalProductSelect++;

                let grades = [{
                    default: productItem.default,
                    gradeId: productItem.id,
                    gradeTitle: productItem.grade_title,
                    inventory: productItem.inventory,
                    marketPrice: productItem.marketPrice,
                    min_amount: productItem.min_amount,
                    ourPrice: productItem.ourPrice,
                    unit: productItem.unit,
                }];
                // console.log(localStorage.getItem('storeSelected'));
                let data = {
                    category_id: productItem.shopId, 
                    category_title: productItem.shopTitle,
                    desc_show: productItem.desc_show,
                    description: productItem.description,
                    grade_header: "",
                    grade_title: productItem.grade_title, 
                    grades: grades, 
                    images: [productItem.big_image], 
                    name: productItem.name, 
                    productId: productItem.productId, 
                }

                grades[0].number_input = productItem.selectedAmount;
                let selectGrade = grades[0]; 
                selectGrade.forFoodPack = match.params.id;
                dispatch(actionAddItemInSHoppingCard(data, selectGrade, productItem.selectedAmount, null));
                // console.log("okeyeeee??????/");
                // console.log(data);
                // console.log(selectGrade);
            }
            else { // bayad check konim age too sabade kharid hast hazf konim
                if (carts.length > 0) {
                    const find_card = carts.find(cart => {
                        return cart.grades[0].gradeId === productItem.id ? cart : null;
                    });

                    if (find_card) 
                        // console.log("in cart: " + productItem.id);
                        dispatch(actionRemoveItemInBasketCart(productItem.id))
                }
            }
        });
        other_products.forEach(productItem => {
            if (productItem.is_check) {
                totalProductSelect++;

                let grades = [{
                    default: productItem.default,
                    gradeId: productItem.id,
                    gradeTitle: productItem.grade_title,
                    inventory: productItem.inventory,
                    marketPrice: productItem.marketPrice,
                    min_amount: productItem.min_amount,
                    ourPrice: productItem.ourPrice,
                    unit: productItem.unit,
                }];
                let data = {
                    category_id: productItem.shopId, 
                    category_title: productItem.shopTitle,
                    desc_show: productItem.desc_show,
                    description: productItem.description,
                    grade_header: "",
                    grade_title: productItem.grade_title, 
                    grades: grades, 
                    images: [productItem.big_image], 
                    name: productItem.name, 
                    productId: productItem.productId, 
                }

                grades[0].number_input = productItem.selectedAmount;
                let selectGrade = grades[0]; 
                selectGrade.forFoodPack = match.params.id;
                dispatch(actionAddItemInSHoppingCard(data, selectGrade, productItem.selectedAmount, null));
                
            }
            else { // bayad check konim age too sabade kharid hast hazf konim
                if (carts.length > 0) {
                    const find_card = carts.find(cart => {
                        return cart.grades[0].gradeId === productItem.id ? cart : null;
                    });

                    if (find_card) 
                        // console.log("in cart: " + productItem.id);
                        dispatch(actionRemoveItemInBasketCart(productItem.id))
                }
            }
        });

        if(totalProductSelect > 0) {
            toast.success("محصولات مورد نظر به سبد خرید اضافه شدند.", {
                position: toast.POSITION.BOTTOM_CENTER
            });
            history.goBack();
        }
        else
        {
            swal({
                title: "خطا",
                text: "حداقل یک محصول انتخاب کنید!",
                buttons: {
                    cancel: "تایید",
                },
                icon: "error",
            });
        }
    };


    return (
        <div className='page-food-pack'>
            <div className='food-pack-main' style={{marginTop: '55px'}}>
                <div>
                    {width > 576 &&
                    <div>
                        {banners.length === 1 ?
                            <LazyLoadImage
                                alt={banners[0].big}
                                src={PUBLIC_URL_SERVER + IMG_SLIDER_FOOD_PACKAGE_URL_SERVER + banners[0].big}
                                width={'100%'}
                            />
                            :
                            <Swiper slidesPerView={1} pagination={{clickable: true}} autoplay={{delay: 3500, disableOnInteraction: false}} loop={true}>
                                {_.map(banners, (banner, index) => (
                                    <SwiperSlide key={index}>
                                        <LazyLoadImage
                                            alt={banner.big}
                                            src={PUBLIC_URL_SERVER + IMG_SLIDER_FOOD_PACKAGE_URL_SERVER + banner.big}
                                            width={'100%'}
                                        />
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        }
                    </div>
                    }
                </div>

                <Container>
                    <div>
                        {width < 576 &&
                        <div>
                            {banners.length === 1 ?
                                <LazyLoadImage
                                    alt={banners[0].small}
                                    src={PUBLIC_URL_SERVER + IMG_SLIDER_FOOD_PACKAGE_URL_SERVER + banners[0].small}
                                    width={'100%'}
                                />
                                :
                                <Swiper slidesPerView={1} pagination={{clickable: true}} autoplay={{delay: 3500, disableOnInteraction: false}} loop={true}>
                                    {_.map(banners,(banner, index) => (
                                        <SwiperSlide key={index}>
                                            <LazyLoadImage
                                                alt={banner.small}
                                                src={PUBLIC_URL_SERVER + IMG_SLIDER_FOOD_PACKAGE_URL_SERVER + banner.small}
                                                width={'100%'}
                                            />
                                        </SwiperSlide>
                                    ))}
                                </Swiper>
                            }
                        </div>
                        }
                    </div>



                    <div className={'text-center'}>
                        <div className={'h3 mt-4'}>
                            <span>{title}</span>
                        </div>

                        <div className="row justify-content-center mt-4">
                            <div className="col-3 col-md-2">
                                <span className="info-head-light">کالری</span>
                                <br />
                                <span className="info-content-dark">{calory}</span>
                            </div>
                            <div className="col-3 col-md-2 border-right">
                                <span className="info-head-light">تعداد</span>
                                <br />
                                <span className="info-content-dark">{count}</span>
                            </div>
                            <div className="col-3 col-md-2 p-0 border-right">
                                <span className="info-head-light">زمان</span>
                                <br />
                                <span className="info-content-dark">{duration} دقیقه</span>
                            </div>
                        </div>

                        <Container>
                            <div><div>
                                <div className="row text-justify mt-4">
                                    <Container>
                                        {description}
                                    </Container>
                                </div>
                            </div></div>
                        </Container>

                    </div>




                    <div className={'base-box-page-more-products'}>
                        {Object.keys(basic_products).length > 0 ?
                            <React.Fragment>
                                <div className={'box-page-more-products'}>
                                    <div className={'box-header-page-more-products'}>
                                        <h5 className={'txt-title-header-page-more-products'}>مواد تشکیل دهنده اصلی</h5>
                                    </div>
                                    <div className={'box-list-items-page-more-products'}>
                                        <Row>
                                            {typeof basic_products !== "undefined"
                                                ? basic_products.map(  (item) => 
                                                    <Col xs={6} sm={6} md={4} lg={4} key={item.id}>
                                                        <CardProduct product={item} forFoodPack={true} isBasic={true}/>
                                                    </Col>)
                                                : ''}
                                        </Row>
                                    </div>
                                </div>

                                <div className={'box-page-more-products'} style={{marginTop: '40px'}}>
                                    <div className={'box-header-page-more-products'}>
                                        <h5 className={'txt-title-header-page-more-products'}>دیگر مواد تشکیل دهنده</h5>
                                    </div>
                                    <div className={'box-list-items-page-more-products'}>
                                        <Row>
                                            {typeof other_products !== "undefined"
                                                ? other_products.map((item) =>
                                                    <Col xs={6} sm={6} md={4} lg={4} key={item.id}>
                                                        <CardProduct product={item} forFoodPack={true} isBasic={false} />
                                                    </Col>)
                                                : ''}
                                        </Row>
                                    </div>
                                </div>


                                <div className={'box-page-more-products'} style={{marginTop: '40px'}}>
                                    <div className={'box-header-page-more-products'}>
                                        <h5 className={'txt-title-header-page-more-products'}>لیست مواد مورد نیاز</h5>
                                    </div>
                                    <div className={'box-list-items-page-more-products'}>
                                        <Row>
                                            <Col >
                                                {
                                                    ingredients_list.split('\n').map((line, i) => (
                                                        <span key={i}>
                                                            {line}
                                                            <br/>
                                                        </span>
                                                    ))
                                                }
                                            </Col>
                                        </Row>
                                    </div>
                                </div>


                                <div className={'box-page-more-products'} style={{marginTop: '40px'}}>
                                    <div className={'box-header-page-more-products'}>
                                        <h5 className={'txt-title-header-page-more-products'}>دستور پخت</h5>
                                    </div>
                                    <div className={'box-list-items-page-more-products'}>
                                        <Row>
                                            <Col  >
                                                {
                                                    instructions.split('\n').map((line, i) => (
                                                        <span key={i}>
                                                            {line}
                                                            <br/>
                                                        </span>
                                                    ))
                                                }
                                            </Col>
                                        </Row>
                                    </div>
                                </div>

                            </React.Fragment>
                            : ''}
                    </div>


                    <Fab 
                        className="mui-fab-custom"
                        variant="extended" 
                        aria-label="add"
                        color="#42b029"
                        sx={{
                            color: 'white',
                            fontFamily: 'IYekan', 
                            // '&.MuiFab-root' : { position: 'fixed', bottom: '15px', left: '15px', borderRadius: '4px', backgroundColor: '#42b029', zIndex: '1'}
                            '&.MuiFab-root' : { position: 'fixed', bottom: '5px', left: '50%', transform: 'translate(-50%, -50%)', borderRadius: '4px', backgroundColor: '#42b029', zIndex: '1'}
                        }}
                        onClick={handelAddToShoppingCard}
                        >
                        {num_of_checked_products === 0 ? 'حذف محصولات این پکیج از سبد خرید' : (num_of_checked_products <= first_num_of_checked_products ? 'اعمال تغییرات در سبد خرید' : ('افزودن  ' + num_of_checked_products + '  محصول به سبد خرید')) }
                        
                    </Fab>

                    

                </Container>

            </div>

            
            

        </div>
    );
}

export default FoodPackage;
